import React from "react";

function Facebook() {
  return (
    <svg
      width="8"
      height="18"
      viewBox="0 0 8 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00012 6.49578L7.69112 9.42578H5.34912V17.9258H1.83113V9.42578H0.078125V6.49578H1.83113V4.73178C1.83113 2.34878 2.82212 0.925781 5.63912 0.925781H7.98012V3.85578H6.51512C5.42212 3.85578 5.34912 4.26878 5.34912 5.03178V6.49578H8.00012Z"
        fill="#121212"
      />
    </svg>
  );
}

export default Facebook;
